/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetWebConfigResponse } from '../model';
// @ts-ignore
import { WebConfigRequest } from '../model';
/**
 * WebConfigsApi - axios parameter creator
 * @export
 */
export const WebConfigsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultWebConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/web-configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebConfigRequest} webConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultWebConfig: async (webConfigRequest: WebConfigRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webConfigRequest' is not null or undefined
            assertParamExists('updateDefaultWebConfig', 'webConfigRequest', webConfigRequest)
            const localVarPath = `/api/web-configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebConfigsApi - functional programming interface
 * @export
 */
export const WebConfigsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebConfigsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultWebConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWebConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultWebConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WebConfigRequest} webConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultWebConfig(webConfigRequest: WebConfigRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWebConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefaultWebConfig(webConfigRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebConfigsApi - factory interface
 * @export
 */
export const WebConfigsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebConfigsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultWebConfig(options?: any): AxiosPromise<GetWebConfigResponse> {
            return localVarFp.getDefaultWebConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebConfigRequest} webConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultWebConfig(webConfigRequest: WebConfigRequest, options?: any): AxiosPromise<GetWebConfigResponse> {
            return localVarFp.updateDefaultWebConfig(webConfigRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateDefaultWebConfig operation in WebConfigsApi.
 * @export
 * @interface WebConfigsApiUpdateDefaultWebConfigRequest
 */
export interface WebConfigsApiUpdateDefaultWebConfigRequest {
    /**
     * 
     * @type {WebConfigRequest}
     * @memberof WebConfigsApiUpdateDefaultWebConfig
     */
    readonly webConfigRequest: WebConfigRequest
}

/**
 * WebConfigsApi - object-oriented interface
 * @export
 * @class WebConfigsApi
 * @extends {BaseAPI}
 */
export class WebConfigsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebConfigsApi
     */
    public getDefaultWebConfig(options?: AxiosRequestConfig) {
        return WebConfigsApiFp(this.configuration).getDefaultWebConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebConfigsApiUpdateDefaultWebConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebConfigsApi
     */
    public updateDefaultWebConfig(requestParameters: WebConfigsApiUpdateDefaultWebConfigRequest, options?: AxiosRequestConfig) {
        return WebConfigsApiFp(this.configuration).updateDefaultWebConfig(requestParameters.webConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
